import React, { useEffect, useState } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import axios from 'axios';

  // *** NOTE - !!!NEVER!!! USE THIS COMPONENT FOR SVG CONTENT THAT IS NOT HOSTED ON OUR CDN ***

  /**
   * In order to furnish exterior svg content (and make use of our CDN), we need to fetch the svg content from the url.
   * This is different from how we utilize svg content in the logo, where we import the svg file directly.
   * The reason for the different approach is so that we can make use (easily) of the intrinsic mui icon button styling
   * via the SvgIcon component.
   * Want to Know More? https://v4.mui.com/components/icons/#svgicon
   * 
   */
function CustomSvgIcon(props) {
  const [svgContent, setSvgContent] = useState('');
  const { url, ...otherProps } = props;

  useEffect(() => {
    const fetchSvg = async () => {
      try {
        const response = await axios.get(url, { responseType: 'text' });
        setSvgContent(response.data);
      } catch (error) {
        console.error('Error fetching SVG:', error);
      }
    };

    fetchSvg();
  }, [url]);

  return (
    <SvgIcon {...otherProps}>
      <g dangerouslySetInnerHTML={{ __html: svgContent }} />
    </SvgIcon>
  );
}

export default CustomSvgIcon;